import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getResourceSliceContent = createAsyncThunk('/resources/content', async () => {
    var userData=JSON.parse(localStorage.getItem("userData"));
	const response = await axios.post(`${API_URL}/getResource`, {});
	return response;
})

export const resourceSlice = createSlice({
    name: 'resources',
    initialState: {
        isLoading: false,
        resources : []
    },
    reducers: {
    },
    extraReducers: {
		[getResourceSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getResourceSliceContent.fulfilled]: (state, action) => {
			state.resources = action.payload.data
			state.isLoading = false
		},
		[getResourceSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default resourceSlice.reducer